<template>
  <div id="basketball_playerDetail" v-show="currThemeObj">
    <div class="abs_top">
      <playerDetail_basePanel
        :currThemeObj="currThemeObj"
        :matchInfor="matchPanel_baseInfor"
        :playerList="matchPanel_playerList"
        @selectChangeVal="selectChangeValHandler"
      ></playerDetail_basePanel>
      <div class="selectTab_area">
        <selectTab
          :currThemeObj="currThemeObj"
          :tabArr="tabArr"
          :pageJumpParams="selectTab_pageJumpParams"
          @clickTabEvent="onChangeTab"
          :colorsArr="selectTab_colorsArr"
        ></selectTab>
      </div>
    </div>
    <div>
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :matchInfor="matchPanel_baseInfor"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :curTimeZoneItem="curTimeZoneItem"
      ></router-view>
    </div>
  </div>
</template>

<script>
import playerDetail_basePanel from './playerDetail_basePanel'
import selectTab from '@components/platfromBase/compreSportsMeet/selectTab.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

import { https_playerDetail_baseInfor } from '@api/platfrom_basketball_api'
export default {
  name: 'basketball_playerDetail',
  components: { playerDetail_basePanel, selectTab },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      isRefresh: false, //是否需要实时更新
      refreshTime: 30 * 1000, //定时器刷的时间 默认
      setIntervalId: null,
      matchPanel_playerList: [],
      matchPanel_baseInfor: {
        baseInfo: {},
        stat: {},
      },
      tabArr: [
        {
          name: '综合数据',
          id: 'seasonData',
          pathName: 'playerDetailSeasonData',
          act: true,
        },
        {
          name: '生涯数据',
          id: 'careerData',
          pathName: 'playerDetailCareerData',
          act: false,
        },
        {
          name: '比赛统计',
          id: 'matchRecord',
          pathName: 'playerDetailMatchRecord',
          act: false,
        },
      ],
      selectTab_pageJumpParams: [],
      selectTab_colorsArr: null,
      selectTab_colorsKey: [
        'greyColor7',
        'whiteColor',
        'greyColor2',
        'subColor1_1',
      ],
    }
  },
  watch: {
    isRefresh(newVal, oldVal) {
      console.debug(`lineup isRefresh: ${newVal}, ${oldVal}`)
      if (newVal && !oldVal) {
        this.refreshCallbackHandle()
      } else if (!newVal && oldVal) {
        this.cancelRefreshCallBackHandle()
      }
    },
  },
  created() {
    if (this.currThemeObj) {
      this.tabArr.forEach((item) => {
        item.pathName = `${item.pathName}_${this.currThemeObj.moduleRouteNameEn}` // teamDetailPlayerList_CBA
      })
    }
    const query = this.$route.query
    this.selectTab_pageJumpParams = [query, null]
    this.init(query)
  },
  methods: {
    async init(params) {
      if (params) {
        if (this.currThemeObj) {
          this.selectTab_colorsArr = this.selectTab_colorsKey.map((key) => {
            return this.currThemeObj.cssStyle[key]
          })
        }
        // this.origin_matchList = matchList_mock.dat
        await this.getPlayerDetail(params)
      }
    },
    formatRanAbbrHandler(num) {
      if (!num) {
        return '-'
      }
      let ceil = ''
      if (num === 1) {
        ceil = 'st'
      } else if (num === 2) {
        ceil = 'nd'
      } else if (num === 3) {
        ceil = 'rd'
      } else {
        ceil = 'th'
      }
      return `${num}${ceil}`
    },
    cancelRefreshCallBackHandle() {
      clearInterval(this.setIntervalId)
      this.setIntervalId = null
    },
    refreshCallbackHandle() {
      const query = this.$route.query
      this.setIntervalId = setInterval(() => {
        this.getPlayerDetail(query)
      }, this.refreshTime - 0)
    },
    onChangeTab(item) {
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
    },
    selectChangeValHandler(data) {
      if (data.state === 'playerName') {
        this.updatePlayerIdHanlder(data.val)
      }
    },
    updatePlayerIdHanlder(playerId) {
      let [query, params] = this.selectTab_pageJumpParams
      //   let isChangeQueryFlag = false
      console.debug('updatePlayerIdHanlder:', params, query)
      if (query.pid && query.pid !== playerId) {
        let newQuery = JSON.parse(JSON.stringify(query))
        newQuery.pid = playerId

        console.debug('updatePlayerIdHanlder:', newQuery)
        this.selectTab_pageJumpParams = [newQuery, params]
        this.$router.push({
          query: newQuery,
          params: params,
        })
        this.getPlayerDetail(newQuery)
      }
    },
    async getPlayerDetail(query) {
      await https_playerDetail_baseInfor(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let { baseInfo, stat, players } = res.data
            baseInfo.playerLogo = baseInfo.profilePicture
            baseInfo.shirtNumberWeb = baseInfo.jerseyNumber
              ? `#${baseInfo.jerseyNumber}`
              : ''

            stat.pointsWeb = stat.points
              ? `${stat.points} ${
                  stat.rank ? this.formatRanAbbrHandler(stat.rank) : ''
                }`
              : ''
            this.matchPanel_baseInfor = {
              baseInfo,
              stat,
              players,
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_baseInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#basketball_playerDetail {
  padding-top: 20.833vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 20.833vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_detail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .selectTab_area {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0 9.722vw;
      width: 100%;
      height: 2.778vw;
    }
  }
}
</style>
